import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function AirCoolerDevice(props) {
	return <DeviceItem {...props} data={DeviceData.AIR_COOLER} />;
}

export default AirCoolerDevice;
